module.exports = __webpack_public_path__ + "img/bg_avatar_male_52.ab034617.png";